import { useQueries } from '@tanstack/react-query';

import { useCartStore } from '@lib/stores/useCartStore';
import { ProductService } from '@lib/product/services';
import { Product } from '@lib/product/definitions';
import { useClient } from '@lib/hooks/useClient';

export function useCartProducts() {
  const cart = useCartStore((state) => state.cart);
  const isClient = useClient();

  const items = useQueries({
    queries: (cart?.productIds ?? []).map((productId) => {
      return {
        queryKey: ['cart-products', productId],
        queryFn: async () => {
          try {
            const product = await ProductService.getProductById(productId);
            return product.isSold ? undefined : product;
          } catch {
            return undefined;
          }
        },
      };
    }),
  });

  const isLoading = items.some((query) => query.isLoading) || !isClient;

  const cartProducts = items
    .map((query) => query.data)
    .filter((product): product is Product => product !== undefined);

  return { cartProducts, isLoading };
}
